import { Flex, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { StatBox } from '@feathr/components';

import { formatCurrency, formatNumber } from '../ConversionTableCard.utils';

interface IProps {
  totalValue: number;
  totalCount: number;
}

function ConversionSummaryStats({ totalValue, totalCount }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const { spacing } = useMantineTheme();

  return (
    <Flex gap={spacing[4]}>
      <StatBox
        border={'full'}
        label={t('Conversion value')}
        primary={formatCurrency(totalValue)}
        tooltip={t('Total value of all conversions')}
      />
      <StatBox
        border={'full'}
        label={t('Conversions')}
        primary={formatNumber(totalCount)}
        tooltip={t('Total number of conversions')}
      />
    </Flex>
  );
}

export default ConversionSummaryStats;
